module.exports = __webpack_public_path__ + "files/9061212809b4b782f82140a237b2690f.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo_compact.png
// module id = 925
// module chunks = 76